import { useWSQuery } from "@ws-react-query";
import { UseQueryOptions } from "@tanstack/react-query";
import type { insuranceMonitorApiSpec } from "@wingspanhq/wingspan-api-types";
import { WSServiceError } from "../../../utils/serviceHelper";
import { getInsuranceCoverageMonitor } from "../../../services/api/insurance/monitor/getInsuranceCoverageMonitor";

type InsuranceCoverageMonitor =
  insuranceMonitorApiSpec.InsuranceCoverageMonitor;

export const QUERY_INSURANCE_COVERAGE_MONITOR =
  "QUERY_INSURANCE_COVERAGE_MONITOR";

export const useQueryInsuranceCoverageMonitor = (
  requestId: string,
  options?: UseQueryOptions<InsuranceCoverageMonitor, WSServiceError>
) => {
  return useWSQuery<InsuranceCoverageMonitor, WSServiceError>(
    [QUERY_INSURANCE_COVERAGE_MONITOR, requestId],
    () => getInsuranceCoverageMonitor(requestId),
    {
      enabled: !!requestId,
      ...options
    }
  );
};
